// The payload a local panel hands to onSubmit, in the shape of the library's own Footer (Components/Footer/index.tsx,
// handleSubmit), so the host treats ours and the library's alike. type, format and destination are fixed: a panel's
// message goes out through Bloomreach's webhook, never directly, so destination is always ''. isTemplate is Enterprise's
// rule (isTypeTemplate in templateModel.js). The optional fields are added only when given, as the Footer sets its own
// conditionally. location, buttonUrlParam and ctaButtonUrl are the Standard panel's; the carousel passes none.
import { isTypeTemplate } from './templateModel';

/**
 * @typedef {object} BuildSubmitDataInput
 * @property {{ details: { id: (string|number), body?: string, type?: string, button_type?: string } }} template - selected template; details.id/body/button_type are read
 * @property {string} channelId
 * @property {string} orgId
 * @property {string[]} [params] - body variable values
 * @property {string[]} [headerParams] - header variable values, defaults to []
 * @property {string} messageType - lowercase message type, e.g. 'text', 'image', 'location'
 * @property {object} [waTemplateJson] - wire JSON for a COMPLEX/CAROUSEL/LTO send
 * @property {string} [subType] - sub_type, e.g. 'CAROUSEL' | 'COMPLEX' | 'LTO'
 * @property {string} [mediaUrl]
 * @property {{ latitude: string, longitude: string, name: string, address: string }} [location]
 * @property {string} [buttonUrlParam] - single DYNAMIC button's suffix
 * @property {string} [ctaButtonUrl] - single DYNAMIC_LINK_TRACK button's full URL
 * @property {object} [extra] - extra fields merged in as-is (e.g. fileName)
 */

/**
 * @param {BuildSubmitDataInput} input
 * @returns {object} the library-shaped submit payload
 */
export function buildSubmitData({
  template, channelId, orgId, params, headerParams = [], messageType, waTemplateJson, subType, mediaUrl, location, buttonUrlParam, ctaButtonUrl, extra,
}) {
  const data = {
    type: 'enterprise',
    params,
    headerParams,
    message: template.details.body,
    templateId: String(template.details.id),
    messageType,
    destination: '',
    format: 'json',
    channelId,
    orgId,
    isTemplate: isTypeTemplate(template.details),
  };
  if (mediaUrl !== undefined) data.mediaUrl = mediaUrl;
  if (waTemplateJson !== undefined) data.waTemplateJson = waTemplateJson;
  if (subType !== undefined) data.sub_type = subType;
  if (location !== undefined) data.location = location;
  if (buttonUrlParam !== undefined) data.buttonUrlParam = buttonUrlParam;
  if (ctaButtonUrl !== undefined) data.ctaButtonUrl = ctaButtonUrl;
  if (extra) Object.assign(data, extra);
  return data;
}
